import { render, staticRenderFns } from "./CashCallRedirect.vue?vue&type=template&id=2095bb36"
import script from "./CashCallRedirect.vue?vue&type=script&lang=js"
export * from "./CashCallRedirect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports